/**
 * Created by Jasmine on 2019/5/29.
 */

import { observable, action } from "mobx";
import { request, apis } from '../../../utils/net';

class Store{
    @observable.shallow billList = [] // 账单列表

    // 获取账单列表
    @action getBillList() {
        request({
            url: apis.getBillList
        }).then(res => {
            this.billList = res || []
        })
    }

    // 生成账单
    @action submitBill(param) {
        return request({
            url: apis.submitBill,
            method: 'POST',
            data: param
        })
    }
}

export default new Store()
